
function $parcel$interopDefault(a) {
  return a && a.__esModule ? a.default : a;
}

      var $parcel$global =
        typeof globalThis !== 'undefined'
          ? globalThis
          : typeof self !== 'undefined'
          ? self
          : typeof window !== 'undefined'
          ? window
          : typeof global !== 'undefined'
          ? global
          : {};
  
var $parcel$modules = {};
var $parcel$inits = {};

var parcelRequire = $parcel$global["parcelRequire94c2"];

if (parcelRequire == null) {
  parcelRequire = function(id) {
    if (id in $parcel$modules) {
      return $parcel$modules[id].exports;
    }
    if (id in $parcel$inits) {
      var init = $parcel$inits[id];
      delete $parcel$inits[id];
      var module = {id: id, exports: {}};
      $parcel$modules[id] = module;
      init.call(module.exports, module, module.exports);
      return module.exports;
    }
    var err = new Error("Cannot find module '" + id + "'");
    err.code = 'MODULE_NOT_FOUND';
    throw err;
  };

  parcelRequire.register = function register(id, init) {
    $parcel$inits[id] = init;
  };

  $parcel$global["parcelRequire94c2"] = parcelRequire;
}

var parcelRegister = parcelRequire.register;
parcelRegister("jsg6F", function(module, exports) {
// Copyright (c) 2013 Pieroxy <pieroxy@pieroxy.net>
// This work is free. You can redistribute it and/or modify it
// under the terms of the WTFPL, Version 2
// For more information see LICENSE.txt or http://www.wtfpl.net/
//
// For more information, the home page:
// http://pieroxy.net/blog/pages/lz-string/testing.html
//
// LZ-based compression algorithm, version 1.4.5
var LZString = function() {
    // private property
    var f = String.fromCharCode;
    var keyStrBase64 = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";
    var keyStrUriSafe = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+-$";
    var baseReverseDic = {};
    function getBaseValue(alphabet, character) {
        if (!baseReverseDic[alphabet]) {
            baseReverseDic[alphabet] = {};
            for(var i = 0; i < alphabet.length; i++)baseReverseDic[alphabet][alphabet.charAt(i)] = i;
        }
        return baseReverseDic[alphabet][character];
    }
    var LZString = {
        compressToBase64: function(input) {
            if (input == null) return "";
            var res = LZString._compress(input, 6, function(a) {
                return keyStrBase64.charAt(a);
            });
            switch(res.length % 4){
                default:
                case 0:
                    return res;
                case 1:
                    return res + "===";
                case 2:
                    return res + "==";
                case 3:
                    return res + "=";
            }
        },
        decompressFromBase64: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrBase64, input.charAt(index));
            });
        },
        compressToUTF16: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 15, function(a) {
                return f(a + 32);
            }) + " ";
        },
        decompressFromUTF16: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 16384, function(index) {
                return compressed.charCodeAt(index) - 32;
            });
        },
        //compress into uint8array (UCS-2 big endian format)
        compressToUint8Array: function(uncompressed) {
            var compressed = LZString.compress(uncompressed);
            var buf = new Uint8Array(compressed.length * 2); // 2 bytes per character
            for(var i = 0, TotalLen = compressed.length; i < TotalLen; i++){
                var current_value = compressed.charCodeAt(i);
                buf[i * 2] = current_value >>> 8;
                buf[i * 2 + 1] = current_value % 256;
            }
            return buf;
        },
        //decompress from uint8array (UCS-2 big endian format)
        decompressFromUint8Array: function(compressed) {
            if (compressed === null || compressed === undefined) return LZString.decompress(compressed);
            else {
                var buf = new Array(compressed.length / 2); // 2 bytes per character
                for(var i = 0, TotalLen = buf.length; i < TotalLen; i++)buf[i] = compressed[i * 2] * 256 + compressed[i * 2 + 1];
                var result = [];
                buf.forEach(function(c) {
                    result.push(f(c));
                });
                return LZString.decompress(result.join(''));
            }
        },
        //compress into a string that is already URI encoded
        compressToEncodedURIComponent: function(input) {
            if (input == null) return "";
            return LZString._compress(input, 6, function(a) {
                return keyStrUriSafe.charAt(a);
            });
        },
        //decompress from an output of compressToEncodedURIComponent
        decompressFromEncodedURIComponent: function(input) {
            if (input == null) return "";
            if (input == "") return null;
            input = input.replace(/ /g, "+");
            return LZString._decompress(input.length, 32, function(index) {
                return getBaseValue(keyStrUriSafe, input.charAt(index));
            });
        },
        compress: function(uncompressed) {
            return LZString._compress(uncompressed, 16, function(a) {
                return f(a);
            });
        },
        _compress: function(uncompressed, bitsPerChar, getCharFromInt) {
            if (uncompressed == null) return "";
            var i, value, context_dictionary = {}, context_dictionaryToCreate = {}, context_c = "", context_wc = "", context_w = "", context_enlargeIn = 2, context_dictSize = 3, context_numBits = 2, context_data = [], context_data_val = 0, context_data_position = 0, ii;
            for(ii = 0; ii < uncompressed.length; ii += 1){
                context_c = uncompressed.charAt(ii);
                if (!Object.prototype.hasOwnProperty.call(context_dictionary, context_c)) {
                    context_dictionary[context_c] = context_dictSize++;
                    context_dictionaryToCreate[context_c] = true;
                }
                context_wc = context_w + context_c;
                if (Object.prototype.hasOwnProperty.call(context_dictionary, context_wc)) context_w = context_wc;
                else {
                    if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                        if (context_w.charCodeAt(0) < 256) {
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 8; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        } else {
                            value = 1;
                            for(i = 0; i < context_numBits; i++){
                                context_data_val = context_data_val << 1 | value;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = 0;
                            }
                            value = context_w.charCodeAt(0);
                            for(i = 0; i < 16; i++){
                                context_data_val = context_data_val << 1 | value & 1;
                                if (context_data_position == bitsPerChar - 1) {
                                    context_data_position = 0;
                                    context_data.push(getCharFromInt(context_data_val));
                                    context_data_val = 0;
                                } else context_data_position++;
                                value = value >> 1;
                            }
                        }
                        context_enlargeIn--;
                        if (context_enlargeIn == 0) {
                            context_enlargeIn = Math.pow(2, context_numBits);
                            context_numBits++;
                        }
                        delete context_dictionaryToCreate[context_w];
                    } else {
                        value = context_dictionary[context_w];
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    // Add wc to the dictionary.
                    context_dictionary[context_wc] = context_dictSize++;
                    context_w = String(context_c);
                }
            }
            // Output the code for w.
            if (context_w !== "") {
                if (Object.prototype.hasOwnProperty.call(context_dictionaryToCreate, context_w)) {
                    if (context_w.charCodeAt(0) < 256) {
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 8; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    } else {
                        value = 1;
                        for(i = 0; i < context_numBits; i++){
                            context_data_val = context_data_val << 1 | value;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = 0;
                        }
                        value = context_w.charCodeAt(0);
                        for(i = 0; i < 16; i++){
                            context_data_val = context_data_val << 1 | value & 1;
                            if (context_data_position == bitsPerChar - 1) {
                                context_data_position = 0;
                                context_data.push(getCharFromInt(context_data_val));
                                context_data_val = 0;
                            } else context_data_position++;
                            value = value >> 1;
                        }
                    }
                    context_enlargeIn--;
                    if (context_enlargeIn == 0) {
                        context_enlargeIn = Math.pow(2, context_numBits);
                        context_numBits++;
                    }
                    delete context_dictionaryToCreate[context_w];
                } else {
                    value = context_dictionary[context_w];
                    for(i = 0; i < context_numBits; i++){
                        context_data_val = context_data_val << 1 | value & 1;
                        if (context_data_position == bitsPerChar - 1) {
                            context_data_position = 0;
                            context_data.push(getCharFromInt(context_data_val));
                            context_data_val = 0;
                        } else context_data_position++;
                        value = value >> 1;
                    }
                }
                context_enlargeIn--;
                if (context_enlargeIn == 0) {
                    context_enlargeIn = Math.pow(2, context_numBits);
                    context_numBits++;
                }
            }
            // Mark the end of the stream
            value = 2;
            for(i = 0; i < context_numBits; i++){
                context_data_val = context_data_val << 1 | value & 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data_position = 0;
                    context_data.push(getCharFromInt(context_data_val));
                    context_data_val = 0;
                } else context_data_position++;
                value = value >> 1;
            }
            // Flush the last char
            while(true){
                context_data_val = context_data_val << 1;
                if (context_data_position == bitsPerChar - 1) {
                    context_data.push(getCharFromInt(context_data_val));
                    break;
                } else context_data_position++;
            }
            return context_data.join('');
        },
        decompress: function(compressed) {
            if (compressed == null) return "";
            if (compressed == "") return null;
            return LZString._decompress(compressed.length, 32768, function(index) {
                return compressed.charCodeAt(index);
            });
        },
        _decompress: function(length, resetValue, getNextValue) {
            var dictionary = [], next, enlargeIn = 4, dictSize = 4, numBits = 3, entry = "", result = [], i, w, bits, resb, maxpower, power, c, data = {
                val: getNextValue(0),
                position: resetValue,
                index: 1
            };
            for(i = 0; i < 3; i += 1)dictionary[i] = i;
            bits = 0;
            maxpower = Math.pow(2, 2);
            power = 1;
            while(power != maxpower){
                resb = data.val & data.position;
                data.position >>= 1;
                if (data.position == 0) {
                    data.position = resetValue;
                    data.val = getNextValue(data.index++);
                }
                bits |= (resb > 0 ? 1 : 0) * power;
                power <<= 1;
            }
            switch(next = bits){
                case 0:
                    bits = 0;
                    maxpower = Math.pow(2, 8);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 1:
                    bits = 0;
                    maxpower = Math.pow(2, 16);
                    power = 1;
                    while(power != maxpower){
                        resb = data.val & data.position;
                        data.position >>= 1;
                        if (data.position == 0) {
                            data.position = resetValue;
                            data.val = getNextValue(data.index++);
                        }
                        bits |= (resb > 0 ? 1 : 0) * power;
                        power <<= 1;
                    }
                    c = f(bits);
                    break;
                case 2:
                    return "";
            }
            dictionary[3] = c;
            w = c;
            result.push(c);
            while(true){
                if (data.index > length) return "";
                bits = 0;
                maxpower = Math.pow(2, numBits);
                power = 1;
                while(power != maxpower){
                    resb = data.val & data.position;
                    data.position >>= 1;
                    if (data.position == 0) {
                        data.position = resetValue;
                        data.val = getNextValue(data.index++);
                    }
                    bits |= (resb > 0 ? 1 : 0) * power;
                    power <<= 1;
                }
                switch(c = bits){
                    case 0:
                        bits = 0;
                        maxpower = Math.pow(2, 8);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 1:
                        bits = 0;
                        maxpower = Math.pow(2, 16);
                        power = 1;
                        while(power != maxpower){
                            resb = data.val & data.position;
                            data.position >>= 1;
                            if (data.position == 0) {
                                data.position = resetValue;
                                data.val = getNextValue(data.index++);
                            }
                            bits |= (resb > 0 ? 1 : 0) * power;
                            power <<= 1;
                        }
                        dictionary[dictSize++] = f(bits);
                        c = dictSize - 1;
                        enlargeIn--;
                        break;
                    case 2:
                        return result.join('');
                }
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
                if (dictionary[c]) entry = dictionary[c];
                else {
                    if (c === dictSize) entry = w + w.charAt(0);
                    else return null;
                }
                result.push(entry);
                // Add w+entry[0] to the dictionary.
                dictionary[dictSize++] = w + entry.charAt(0);
                enlargeIn--;
                w = entry;
                if (enlargeIn == 0) {
                    enlargeIn = Math.pow(2, numBits);
                    numBits++;
                }
            }
        }
    };
    return LZString;
}();
if (typeof define === 'function' && define.amd) define(function() {
    return LZString;
});
else if (module != null) module.exports = LZString;
else if (typeof angular !== 'undefined' && angular != null) angular.module('LZString', []).factory('LZString', function() {
    return LZString;
});

});

const $17038909dd410a9a$export$d053022317eb9cd0 = {
    _data: {},
    setItem (id, val) {
        return this._data[id] = String(val);
    },
    getItem (id) {
        return this._data.hasOwnProperty(id) ? this._data[id] : undefined;
    },
    removeItem (id) {
        return delete this._data[id];
    },
    clear () {
        return this._data = {};
    }
};
class $17038909dd410a9a$export$19fffca37ef3e106 {
    constructor(){
        const supported = this.localStorageSupported();
        this.storage = supported ? window.localStorage : $17038909dd410a9a$export$d053022317eb9cd0;
    }
    localStorageSupported() {
        const testKey = 'testRedemptionViewer';
        const storage = window.localStorage;
        try {
            storage.setItem(testKey, '1');
            storage.removeItem(testKey);
            return true;
        } catch (error) {
            return false;
        }
    }
}



var $jsg6F = parcelRequire("jsg6F");
const $5ed221e0a371091e$export$eada748df1dd417f = function() {
    const query_string = {};
    let query = window.location.search.substring(1);
    if (query.length > 0 && !(query.includes('appType=') || query.includes('f='))) // Decompress first
    query = (0, (/*@__PURE__*/$parcel$interopDefault($jsg6F))).decompressFromEncodedURIComponent(query);
    let vars = query.split('&');
    if (query.includes('&amp;')) vars = query.split('&amp;');
    for(let i = 0; i < vars.length; i++){
        const pair = vars[i].split('=');
        // If first entry with this name
        if (typeof query_string[pair[0]] === 'undefined') query_string[pair[0]] = decodeURIComponent(pair[1]);
        else if (typeof query_string[pair[0]] === 'string') {
            const arr = [
                query_string[pair[0]],
                decodeURIComponent(pair[1])
            ];
            query_string[pair[0]] = arr;
        // If third or later entry with this name
        } else query_string[pair[0]].push(decodeURIComponent(pair[1]));
    }
    return query_string;
}();
let $5ed221e0a371091e$var$debugOn = false;
function $5ed221e0a371091e$export$6ff146b8934c4db3() {
    return $5ed221e0a371091e$var$debugOn;
}
function $5ed221e0a371091e$export$76cc65c03f602c2c(value) {
    $5ed221e0a371091e$var$debugOn = value;
}
/* Set to true if building for iOS, else set to false */ const $5ed221e0a371091e$export$e23a29e65f46331c = false;
/* Set to true if building for Android, else set to false */ const $5ed221e0a371091e$export$abe98e58f59f2a7f = false;
const $5ed221e0a371091e$export$5b18cbeeb9113cbc = true;
/* --- */ function $5ed221e0a371091e$export$1c9f709888824e05(str) {
    if ($5ed221e0a371091e$var$debugOn) {
        if ($5ed221e0a371091e$export$e23a29e65f46331c || $5ed221e0a371091e$export$eada748df1dd417f.appType === 'ios') try {
            webkit.messageHandlers.callbackHandler.postMessage(`{debugMessage:${str}}`);
        } catch (err) {
            console.log('error');
        }
        console.log(str);
    }
}
/* Clipboard */ async function $5ed221e0a371091e$export$f980440e1ab4537d(theText, triggerButton) {
    if (!navigator.clipboard) // Clipboard API not available
    return;
    try {
        await navigator.clipboard.writeText(theText);
        if (triggerButton) {
            const btnText = triggerButton.innerText;
            triggerButton.innerText = 'Copied!';
            setTimeout(()=>{
                triggerButton.innerText = btnText;
            }, 3000);
        }
    } catch (err) {
        console.error('Failed to copy!', err);
    }
}
function $5ed221e0a371091e$export$303f1ba6e4d0fc0e(array1, array2) {
    for(let i = 0; i < array2.length; i++){
        if (!array1.includes(array2[i])) return false;
    }
    return true;
}
function $5ed221e0a371091e$export$e9f5b2277b233557(arr) {
    const copyArr = [];
    for(let i = 0; i < arr.length; i++)copyArr.push(arr[i].getCopy());
    return copyArr;
}
// Array shuffle
function $5ed221e0a371091e$export$7ac3a88d34a76e7(array) {
    let i = 0;
    let j = 0;
    let temp = null;
    for(i = array.length - 1; i > 0; i -= 1){
        j = Math.floor(Math.random() * (i + 1));
        temp = array[i];
        array[i] = array[j];
        array[j] = temp;
    }
}
// polyfill
if (!String.prototype.includes) String.prototype.includes = function(search, start) {
    if (typeof start !== 'number') start = 0;
    if (start + search.length > this.length) return false;
    return this.indexOf(search, start) !== -1;
};
if (!Array.prototype.includes) Array.prototype.includes = function(searchElement /* , fromIndex */ ) {
    if (this == null) throw new TypeError('Array.prototype.includes called on null or undefined');
    const O = Object(this);
    const len = parseInt(O.length, 10) || 0;
    if (len === 0) return false;
    const n = parseInt(arguments[1], 10) || 0;
    let k;
    if (n >= 0) k = n;
    else {
        k = len + n;
        if (k < 0) k = 0;
    }
    let currentElement;
    while(k < len){
        currentElement = O[k];
        if (searchElement === currentElement || searchElement !== searchElement && currentElement !== currentElement) return true;
        k++;
    }
    return false;
};
if (!String.prototype.startsWith) String.prototype.startsWith = function(searchString, position) {
    position = position || 0;
    return this.substr(position, searchString.length) === searchString;
};
if (!String.prototype.endsWith) String.prototype.endsWith = function(searchString, position) {
    const subjectString = this.toString();
    if (typeof position !== 'number' || !isFinite(position) || Math.floor(position) !== position || position > subjectString.length) position = subjectString.length;
    position -= searchString.length;
    const lastIndex = subjectString.lastIndexOf(searchString, position);
    return lastIndex !== -1 && lastIndex === position;
};
// Warn if overriding existing method
if (Array.prototype.equals) console.warn("Overriding existing Array.prototype.equals. Possible causes: New API defines the method, there's a framework conflict or you've got double inclusions in your code.");
// attach the .equals method to Array's prototype to call it on any array
Array.prototype.equals = function(array) {
    // if the other array is a falsy value, return
    if (!array) return false;
    // compare lengths - can save a lot of time
    if (this.length != array.length) return false;
    for(let i = 0, l = this.length; i < l; i++){
        // Check if we have nested arrays
        if (this[i] instanceof Array && array[i] instanceof Array) {
            // recurse into the nested arrays
            if (!this[i].equals(array[i])) return false;
        } else if (this[i] != array[i]) // Warning - two different object instances will never be equal: {x:20} != {x:20}
        return false;
    }
    return true;
};
// Hide method from for-in loops
Object.defineProperty(Array.prototype, 'equals', {
    enumerable: false
});


const $f260d5ec6697a36a$var$nameOnlyClass = 'nameOnly';
class $f260d5ec6697a36a$export$60332b2344f7fe41 {
    constructor(dataLine){
        this.jsonData = {
            name: ""
        };
        this.dataLine = dataLine;
        this.dataParts = dataLine.split("\t");
        if (this.dataParts.length !== 15) {
            (0, $5ed221e0a371091e$export$1c9f709888824e05)("Card definition not complete: ");
            (0, $5ed221e0a371091e$export$1c9f709888824e05)(this.dataLine);
        }
        let i = 0;
        this.jsonData.name = this.dataParts[i++];
        this.jsonData.set = this.dataParts[i++];
        this.jsonData.imgFile = this.dataParts[i++];
        this.jsonData.number = this.dataParts[i++];
        this.jsonData.cardType = this.dataParts[i++];
        this.jsonData.level = this.dataParts[i++];
        this.jsonData.powerKind = this.dataParts[i++];
        this.jsonData.virtueScoreOrSinnieDefense = this.dataParts[i++];
        this.jsonData.fellowshipKind = this.dataParts[i++];
        this.jsonData.fellowshipPoints = this.dataParts[i++];
        this.jsonData.activationCost = this.dataParts[i++];
        this.jsonData.abilityText = this.dataParts[i++];
        this.jsonData.weakness = this.dataParts[i++];
        this.jsonData.attribute = this.dataParts[i++];
        this.jsonData.verseReference = this.dataParts[i++];
        this.jsonData.verseText = this.dataParts[i++];
        this.jsonData.artist = this.dataParts[i++];
        this.jsonData.errata = this.dataParts[i++];
        if (this.jsonData.imgFile.includes(".jpg")) this.jsonData.imgFile = this.jsonData.imgFile.replace(".jpg", "");
    }
    getResultListDiv(shouldBuildImageNow, cardImageBaseUrl) {
        const imageUrl = cardImageBaseUrl + this.jsonData.imgFile + ".jpg";
        const theDiv = document.createElement("div");
        theDiv.classList.add("resultCard");
        if (!shouldBuildImageNow) theDiv.classList.add($f260d5ec6697a36a$var$nameOnlyClass);
        const nameDiv = document.createElement("div");
        if ((0, $5ed221e0a371091e$export$6ff146b8934c4db3)()) nameDiv.style["font-weight"] = "bold";
        nameDiv.style["width"] = "95%";
        nameDiv.style["max-width"] = "477px";
        nameDiv.innerText = this.jsonData.name;
        const copyImageLinkButton = document.createElement("button");
        copyImageLinkButton.style["float"] = "right";
        copyImageLinkButton.style["display"] = "none";
        copyImageLinkButton.innerText = "Copy Image Link";
        copyImageLinkButton.onclick = (e)=>{
            (0, $5ed221e0a371091e$export$f980440e1ab4537d)(imageUrl, copyImageLinkButton);
        };
        nameDiv.appendChild(copyImageLinkButton);
        theDiv.appendChild(nameDiv);
        if (shouldBuildImageNow) {
            const theImg = this.buildImageElement(imageUrl, copyImageLinkButton);
            theDiv.appendChild(theImg);
            if (this.jsonData.errata && this.jsonData.errata.length > 0) {
                const errataDiv = this.buildErrataDiv();
                theDiv.appendChild(errataDiv);
            }
        } else theDiv.onclick = (e)=>{
            const theImg = this.buildImageElement(imageUrl, copyImageLinkButton);
            theDiv.appendChild(theImg);
            if ((0, $5ed221e0a371091e$export$6ff146b8934c4db3)()) theDiv.appendChild(this.buildCardInfoElement());
            theDiv.onclick = null;
            theDiv.classList.remove($f260d5ec6697a36a$var$nameOnlyClass);
            if (this.jsonData.errata && this.jsonData.errata.length > 0) {
                const errataDiv = this.buildErrataDiv();
                theDiv.appendChild(errataDiv);
            }
        };
        if ((0, $5ed221e0a371091e$export$6ff146b8934c4db3)() && shouldBuildImageNow) theDiv.appendChild(this.buildCardInfoElement());
        return theDiv;
    }
    buildErrataDiv() {
        const errataDiv = document.createElement("div");
        errataDiv.style["font-style"] = "italic";
        errataDiv.innerText = "Errata: " + this.jsonData.errata;
        return errataDiv;
    }
    buildImageElement(imageUrl, copyImageLinkButton) {
        const theImg = document.createElement("img");
        theImg.src = imageUrl;
        theImg.alt = this.jsonData.name;
        theImg.title = this.jsonData.name;
        theImg.onclick = (e)=>{
            copyImageLinkButton.style["display"] = "";
        };
        return theImg;
    }
    buildCardInfoElement() {
        const cardInfo = document.createElement("pre");
        cardInfo.style["font-style"] = "italic";
        cardInfo.innerHTML = this.allPropertiesStringForDisplay();
        return cardInfo;
    }
    toString() {
        return JSON.stringify(this);
    }
    allPropertiesStringForDisplay() {
        return JSON.stringify(this.jsonData, null, 2);
    }
}



var $jsg6F = parcelRequire("jsg6F");
let $22a4e0717d5a4c53$var$cardDataUrl = "https://raw.githubusercontent.com/thejambi/AnimoLackeyCCG/main/sets/carddata.txt";
let $22a4e0717d5a4c53$var$cardImageBaseUrl = "https://raw.githubusercontent.com/thejambi/AnimoLackeyCCG/main/sets/setimages/general/";
/* For Testing: */ let $22a4e0717d5a4c53$var$cardDataUrlPrev = "file:///Users/zach/Programming/GitHub/RedemptionLackeyCCG/RedemptionQuick/sets/carddata.txt";
let $22a4e0717d5a4c53$var$cardImageBaseUrlPrev = "file:///Users/zach/Programming/GitHub/RedemptionLackeyCCG/RedemptionQuick/sets/setimages/general/";
/* --- */ let $22a4e0717d5a4c53$var$cardListText = "";
let $22a4e0717d5a4c53$var$cardFilterTextBox;
let $22a4e0717d5a4c53$var$filterEchoDiv;
let $22a4e0717d5a4c53$var$resultList;
let $22a4e0717d5a4c53$var$searchLinkTag;
let $22a4e0717d5a4c53$var$baseUrl;
let $22a4e0717d5a4c53$var$localStorage;
let $22a4e0717d5a4c53$var$cardList = [];
const $22a4e0717d5a4c53$var$cardsPerPage = 10; // Number of cards to load per scroll
let $22a4e0717d5a4c53$var$loadedCards = 0; // Counter to track how many cards are loaded so far
window.requestAnimationFrame(function() {
    $22a4e0717d5a4c53$var$cardFilterTextBox = document.getElementById("cardFilterTextBox");
    $22a4e0717d5a4c53$var$resultList = document.getElementById("resultList");
    $22a4e0717d5a4c53$var$filterEchoDiv = document.getElementById("filterEcho");
    $22a4e0717d5a4c53$var$searchLinkTag = document.getElementById("searchLink");
    $22a4e0717d5a4c53$var$localStorage = new (0, $17038909dd410a9a$export$19fffca37ef3e106)().storage;
    $22a4e0717d5a4c53$var$setBaseUrl();
    $22a4e0717d5a4c53$var$loadCardListText();
    $22a4e0717d5a4c53$var$prepareCardFilterTextBox();
    if ((0, $5ed221e0a371091e$export$eada748df1dd417f).f) $22a4e0717d5a4c53$var$cardFilterTextBox.value = (0, $5ed221e0a371091e$export$eada748df1dd417f).f;
    document.getElementById("siteHeading").onclick = function(e) {
        window.location.href = $22a4e0717d5a4c53$var$baseUrl;
    };
    document.getElementById("toggleFilterMenuButton").onclick = function() {
        $22a4e0717d5a4c53$var$toggleFilterMenu();
    };
    document.querySelectorAll('.filterInput').forEach((input)=>{
        input.addEventListener('input', $22a4e0717d5a4c53$var$applyFilter);
        input.addEventListener('change', $22a4e0717d5a4c53$var$applyFilter);
    });
    document.getElementById("addFilterButton").onclick = function() {
        $22a4e0717d5a4c53$var$addAdditionalFilter();
    };
    document.getElementById("clearFiltersButton").onclick = function() {
        $22a4e0717d5a4c53$var$clearFilters();
    };
    $22a4e0717d5a4c53$var$searchLinkTag.href = window.location.href;
    $22a4e0717d5a4c53$var$cardFilterChanged();
});
function $22a4e0717d5a4c53$var$setBaseUrl() {
    $22a4e0717d5a4c53$var$baseUrl = window.location.href.split(/[?#]/)[0];
}
function $22a4e0717d5a4c53$var$prepareCardFilterTextBox() {
    $22a4e0717d5a4c53$var$cardFilterTextBox.oninput = function(e) {
        $22a4e0717d5a4c53$var$cardFilterChanged();
    };
    $22a4e0717d5a4c53$var$cardFilterTextBox.onkeypress = function(e) {
        const code = e.keyCode ? e.keyCode : e.which;
        if (code == 13) $22a4e0717d5a4c53$var$cardFilterChanged();
    };
}
function $22a4e0717d5a4c53$var$loadCardListText() {
    $.get($22a4e0717d5a4c53$var$cardDataUrl, function(data) {
        $22a4e0717d5a4c53$var$cardListText = data;
        $22a4e0717d5a4c53$var$processCardList();
        $22a4e0717d5a4c53$var$populateDropdowns();
    });
}
function $22a4e0717d5a4c53$var$processCardList() {
    const lines = $22a4e0717d5a4c53$var$cardListText.split("\n");
    $22a4e0717d5a4c53$var$cardList = [];
    for(const i in lines){
        const line = lines[i];
        if (i > 0 && line && line.trim() !== "") $22a4e0717d5a4c53$var$cardList.push(new (0, $f260d5ec6697a36a$export$60332b2344f7fe41)(line));
    }
}
let $22a4e0717d5a4c53$var$timeoutId;
const $22a4e0717d5a4c53$var$filterTimeoutWait = 600;
function $22a4e0717d5a4c53$var$cardFilterChanged() {
    clearTimeout($22a4e0717d5a4c53$var$timeoutId);
    (0, $5ed221e0a371091e$export$1c9f709888824e05)("timeout cleared");
    $22a4e0717d5a4c53$var$timeoutId = setTimeout(function() {
        $22a4e0717d5a4c53$var$updateSearchLinkTag();
        $22a4e0717d5a4c53$var$filterCards();
    }, $22a4e0717d5a4c53$var$filterTimeoutWait);
}
function $22a4e0717d5a4c53$var$updateSearchLinkTag() {
    let urlParams = "f=" + encodeURIComponent($22a4e0717d5a4c53$var$cardFilterTextBox.value.trim());
    if (0, $5ed221e0a371091e$export$5b18cbeeb9113cbc) urlParams = (0, (/*@__PURE__*/$parcel$interopDefault($jsg6F))).compressToEncodedURIComponent(urlParams);
    $22a4e0717d5a4c53$var$searchLinkTag.href = $22a4e0717d5a4c53$var$baseUrl + "?" + urlParams;
}
const $22a4e0717d5a4c53$var$requiredFilterLength = 3;
let $22a4e0717d5a4c53$var$applyDeckSort = false;
function $22a4e0717d5a4c53$var$filterCards() {
    const filterTextFull = $22a4e0717d5a4c53$var$cardFilterTextBox.value.trim().toUpperCase();
    $22a4e0717d5a4c53$var$filterEchoDiv.innerText = filterTextFull;
    const filterTextList = filterTextFull.split(";");
    (0, $5ed221e0a371091e$export$1c9f709888824e05)(filterTextList);
    const resultCards = [];
    for(const i in $22a4e0717d5a4c53$var$cardList){
        const card = $22a4e0717d5a4c53$var$cardList[i];
        if (!resultCards.includes(card)) for(const filterTextIndex in filterTextList){
            const filterText = filterTextList[filterTextIndex];
            if ("SORT:DECK" === filterText) $22a4e0717d5a4c53$var$applyDeckSort = true;
            if ("DEBUG:ON" === filterText) (0, $5ed221e0a371091e$export$76cc65c03f602c2c)(true);
            else if ("DEBUG:OFF" === filterText) (0, $5ed221e0a371091e$export$76cc65c03f602c2c)(false);
            if (filterText.length >= $22a4e0717d5a4c53$var$requiredFilterLength && $22a4e0717d5a4c53$var$cardMatchesFilterText(card, filterText)) {
                resultCards.push(card);
                break; // Break out of filters loop, skip to next card
            }
        }
    }
    if ($22a4e0717d5a4c53$var$applyDeckSort) $22a4e0717d5a4c53$var$applyDeckSortToCardsList(resultCards);
    (0, $5ed221e0a371091e$export$1c9f709888824e05)("--- Filter Results ---");
    // Initialize the scroll loading
    $22a4e0717d5a4c53$var$loadedCards = 0;
    $22a4e0717d5a4c53$var$resultList.innerHTML = ''; // Clear the current list
    $22a4e0717d5a4c53$var$loadMoreCards(resultCards);
    // Set up infinite scrolling
    window.onscroll = function() {
        if (window.innerHeight + window.scrollY >= document.body.offsetHeight) $22a4e0717d5a4c53$var$loadMoreCards(resultCards);
    };
}
// Function to load more cards
function $22a4e0717d5a4c53$var$loadMoreCards(resultCards) {
    const end = $22a4e0717d5a4c53$var$loadedCards + $22a4e0717d5a4c53$var$cardsPerPage;
    for(let i = $22a4e0717d5a4c53$var$loadedCards; i < end && i < resultCards.length; i++){
        const card = resultCards[i];
        $22a4e0717d5a4c53$var$resultList.appendChild(card.getResultListDiv(true, $22a4e0717d5a4c53$var$cardImageBaseUrl));
    }
    $22a4e0717d5a4c53$var$loadedCards += $22a4e0717d5a4c53$var$cardsPerPage;
    // Stop scroll event listener if all cards are loaded
    if ($22a4e0717d5a4c53$var$loadedCards >= resultCards.length) window.onscroll = null;
    // Show about text when no search results
    if (resultCards.length === 0) $22a4e0717d5a4c53$var$resultList.appendChild($22a4e0717d5a4c53$var$getAboutDiv());
}
function $22a4e0717d5a4c53$var$applyDeckSortToCardsList(cardList) {
    cardList.sort(function(card1, card2) {
    // Sorting logic here
    });
}
function $22a4e0717d5a4c53$var$cardMatchesFilterText(card, filterText) {
    const filterTextChunks = filterText.trim().split(",");
    let chunkFound = false;
    for(const chunkIndex in filterTextChunks){
        const filterTextChunk = filterTextChunks[chunkIndex].trim();
        if (filterTextChunk.includes(":")) {
            const colonIndex = filterTextChunk.indexOf(":");
            const cardPartStr = filterTextChunk.slice(0, colonIndex);
            if (filterTextChunk.length > colonIndex) {
                const matchValueStr = filterTextChunk.slice(colonIndex + 1);
                let cardPartValue = card.dataLine;
                switch(cardPartStr.toUpperCase()){
                    case "NAME":
                    case "N":
                        cardPartValue = card.jsonData.name;
                        break;
                    case "SET":
                    case "S":
                        cardPartValue = card.jsonData.set;
                        break;
                    case "IMGFILE":
                    case "IF":
                        cardPartValue = card.jsonData.imgFile;
                        break;
                    case "TYPE":
                    case "T":
                        cardPartValue = card.jsonData.cardType;
                        break;
                    case "LEVEL":
                    case "LVL":
                    case "L":
                        cardPartValue = card.jsonData.level;
                        break;
                    case "KIND":
                    case "K":
                        cardPartValue = card.jsonData.powerKind;
                        break;
                    case "SCORE":
                    case "X/":
                        cardPartValue = card.jsonData.virtueScoreOrSinnieDefense;
                        break;
                    case "FELLOWSHIP":
                    case "FK":
                        cardPartValue = card.jsonData.fellowshipKind;
                        break;
                    case "COST":
                    case "C":
                        cardPartValue = card.jsonData.activationCost;
                        break;
                    case "ABILITY":
                    case "A":
                        cardPartValue = card.jsonData.abilityText;
                        break;
                    case "WEAKNESS":
                    case "WEAK":
                    case "W":
                        cardPartValue = card.jsonData.weakness;
                        break;
                    case "ATTRIBUTE":
                        cardPartValue = card.jsonData.attribute;
                        break;
                    case "VERSE":
                    case "REFERENCE":
                    case "REF":
                        cardPartValue = card.jsonData.verseReference;
                        break;
                    case "ARTIST":
                        cardPartValue = card.jsonData.artist;
                        break;
                    case "ERRATA":
                    case "ERR":
                        cardPartValue = card.jsonData.errata;
                        break;
                    default:
                        break;
                }
                if (cardPartValue === undefined) {
                    (0, $5ed221e0a371091e$export$1c9f709888824e05)("No value to match on for card: ");
                    (0, $5ed221e0a371091e$export$1c9f709888824e05)(card);
                } else chunkFound = cardPartValue.toUpperCase().includes(matchValueStr);
            }
        } else chunkFound = card.dataLine.toUpperCase().includes(filterTextChunk);
        if (!chunkFound) return false;
    }
    return chunkFound;
}
function $22a4e0717d5a4c53$var$getAboutDiv() {
    const theDiv = document.createElement("div");
    theDiv.innerHTML = 'Search for cards based on name, set, ability, and more. Use <strong>,</strong> to add another criteria (so, search for <strong>n:Floraline,s:CT</strong> to find cards that match both "Floraline" in name and "CT" in set). Use <strong>;</strong> to add another search.</p>';
    return theDiv;
}
function $22a4e0717d5a4c53$var$toggleFilterMenu() {
    const filterMenu = document.getElementById("filterMenu");
    if (filterMenu.classList.contains("show")) {
        filterMenu.classList.remove("show");
        setTimeout(()=>{
            filterMenu.style.display = "none";
        }, 500);
    } else {
        filterMenu.style.display = "block";
        setTimeout(()=>{
            filterMenu.classList.add("show");
        }, 10);
    }
}
function $22a4e0717d5a4c53$var$applyFilter() {
    const filterName = document.getElementById("filterName").value.trim();
    const filterAbility = document.getElementById("filterAbility").value.trim();
    const filterSet = document.getElementById("filterSet").value.trim();
    const filterType = document.getElementById("filterType").value.trim();
    const filterKind = document.getElementById("filterKind").value.trim();
    const filterLevel = document.getElementById("filterLevel").value.trim();
    const filters = [];
    if (filterName) filters.push("NAME:" + filterName);
    if (filterAbility) filters.push("ABILITY:" + filterAbility);
    if (filterSet) filters.push("SET:" + filterSet);
    if (filterType) filters.push("TYPE:" + filterType);
    if (filterKind) filters.push("KIND:" + filterKind);
    if (filterLevel) filters.push("LEVEL:" + filterLevel);
    let currentFilters = $22a4e0717d5a4c53$var$cardFilterTextBox.value.trim();
    const lastSemiColonIndex = currentFilters.lastIndexOf(";");
    if (lastSemiColonIndex !== -1) currentFilters = currentFilters.substring(0, lastSemiColonIndex + 1);
    else currentFilters = "";
    if (filters.length > 0) $22a4e0717d5a4c53$var$cardFilterTextBox.value = currentFilters + filters.join(",");
    else $22a4e0717d5a4c53$var$cardFilterTextBox.value = currentFilters;
    $22a4e0717d5a4c53$var$cardFilterChanged();
}
function $22a4e0717d5a4c53$var$addAdditionalFilter() {
    const filterName = document.getElementById("filterName").value.trim();
    const filterAbility = document.getElementById("filterAbility").value.trim();
    const filterSet = document.getElementById("filterSet").value.trim();
    const filterType = document.getElementById("filterType").value.trim();
    const filterKind = document.getElementById("filterKind").value.trim();
    const filterLevel = document.getElementById("filterLevel").value.trim();
    const filters = [];
    if (filterName) filters.push("NAME:" + filterName);
    if (filterAbility) filters.push("ABILITY:" + filterAbility);
    if (filterSet) filters.push("SET:" + filterSet);
    if (filterType) filters.push("TYPE:" + filterType);
    if (filterKind) filters.push("KIND:" + filterKind);
    if (filterLevel) filters.push("LEVEL:" + filterLevel);
    if (filters.length > 0) {
        const currentFilters = $22a4e0717d5a4c53$var$cardFilterTextBox.value.trim();
        if (currentFilters) $22a4e0717d5a4c53$var$cardFilterTextBox.value = currentFilters + ";" + filters.join(",");
        else $22a4e0717d5a4c53$var$cardFilterTextBox.value = filters.join(",");
        $22a4e0717d5a4c53$var$cardFilterChanged();
    }
    // Clear the filter builder fields
    document.getElementById("filterName").value = "";
    document.getElementById("filterAbility").value = "";
    document.getElementById("filterSet").value = "";
    document.getElementById("filterType").value = "";
    document.getElementById("filterKind").value = "";
    document.getElementById("filterLevel").value = "";
}
function $22a4e0717d5a4c53$var$clearFilters() {
    document.getElementById("filterName").value = "";
    document.getElementById("filterAbility").value = "";
    document.getElementById("filterSet").value = "";
    document.getElementById("filterType").value = "";
    document.getElementById("filterKind").value = "";
    document.getElementById("filterLevel").value = "";
    $22a4e0717d5a4c53$var$cardFilterTextBox.value = "";
    $22a4e0717d5a4c53$var$cardFilterChanged();
}
function $22a4e0717d5a4c53$var$populateDropdowns() {
    const sets = [
        ...new Set($22a4e0717d5a4c53$var$cardList.map((card)=>card.jsonData.set))
    ].filter(Boolean).sort();
    const types = [
        ...new Set($22a4e0717d5a4c53$var$cardList.map((card)=>card.jsonData.cardType))
    ].filter(Boolean).sort();
    const kinds = [
        ...new Set($22a4e0717d5a4c53$var$cardList.map((card)=>card.jsonData.powerKind))
    ].filter(Boolean).sort();
    const levels = [
        ...new Set($22a4e0717d5a4c53$var$cardList.map((card)=>card.jsonData.level))
    ].filter(Boolean).sort();
    $22a4e0717d5a4c53$var$populateDropdown("filterSet", sets);
    $22a4e0717d5a4c53$var$populateDropdown("filterType", types);
    $22a4e0717d5a4c53$var$populateDropdown("filterKind", kinds);
    $22a4e0717d5a4c53$var$populateDropdown("filterLevel", levels);
}
function $22a4e0717d5a4c53$var$populateDropdown(elementId, options) {
    const dropdown = document.getElementById(elementId);
    options.forEach((option)=>{
        const opt = document.createElement("option");
        opt.value = option;
        opt.innerText = option;
        dropdown.appendChild(opt);
    });
}
function $22a4e0717d5a4c53$var$toggleLocalTesting() {
    (0, $5ed221e0a371091e$export$76cc65c03f602c2c)(true);
    // const newCardDataUrl = cardDataUrlPrev;
    // cardDataUrlPrev = cardDataUrl;
    $22a4e0717d5a4c53$var$cardDataUrl = newCardDataUrl;
    const newImageUrl = $22a4e0717d5a4c53$var$cardImageBaseUrlPrev;
    $22a4e0717d5a4c53$var$cardImageBaseUrlPrev = $22a4e0717d5a4c53$var$cardImageBaseUrl;
    $22a4e0717d5a4c53$var$cardImageBaseUrl = newImageUrl;
    (0, $5ed221e0a371091e$export$1c9f709888824e05)("Card Data Url: " + $22a4e0717d5a4c53$var$cardDataUrl);
    (0, $5ed221e0a371091e$export$1c9f709888824e05)("Card Image Url: " + $22a4e0717d5a4c53$var$cardImageBaseUrl);
    $22a4e0717d5a4c53$var$loadCardListText();
}


//# sourceMappingURL=index.936c26cd.js.map
